import styled from 'styled-components';
import * as colors from '../../common/colorConstants';

export const DescriptionContainer = styled.div`
  position: absolute;
  width: 300px;
  left: -325px;
  top: -25px;
  background-color: ${colors.lightGray10};
  border: 1px solid ${colors.lightGray21};
  border-radius: 4px;
  z-index: 11;
`;

export const DescriptionHeader = styled.div`
  display: flex;
  margin: 10px;
`;

export const DescriptionTitle = styled.div`
  flex: 1;
  font-weight: bold;
`;

export const DescriptionDivider = styled.div`
  border-bottom: 1px solid ${colors.lightGray21};
`;

export const DescriptionCloseButton = styled.img`
  margin: 0;
  cursor: pointer;
`;

export const DescriptionBody = styled.div`
  margin: 10px;
`;
